import style from "./programDisclaimers.module.css"
import Logo from "../../../assets/images/logo.png";
import { NavLink, useSearchParams } from "react-router-dom";
const ProgramDisclaimers = () => {
    const [searchParam] = useSearchParams();
let returnTo = searchParam.get("returnto");
  return (
    <div className={`${style.main_container}`}>
    <div className="intro-y g-col-12 g-col-md-6 g-col-lg-4">
      <div className="search d-none d-sm-block ">
        <h1
          className={`fw-bolder truncate text-center fw-medium ${style.search_font}`}
        >
          Patient Partner Portal
        </h1>
        <p className="text-center">
          Manage All Your Applications, Claims, & Cases in One Place
        </p>
      </div>
    </div>
    <div className={`${style.sub_container}`}>
      <div className=" d-flex justify-content-center pt-2">
        <img src={Logo} alt="logo" className={`${style.logo}`} />
      </div>

      <div className={`${style.title}`}>
        <h2>Program Disclaimers</h2>
      </div>
      <div className={`${style.main_content}`}>
        <div className="">
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit.
            Reiciendis, saepe odit recusandae maxime incidunt esse veritatis
            nesciunt, corporis repellendus error repellat expedita laboriosam,
            sunt provident? Porro omnis quo quis, a nesciunt quod enim nemo
            harum architecto, natus asperiores sed eos molestiae eius beatae,
            facilis
          </p>
          <br />
          <p>
            numquam excepturi? Sed, laborum eius dolore obcaecati sint
            accusamus amet non id error labore! Perferendis accusantium quod
            sapiente tempora laudantium doloribus distinctio harum laboriosam
            pariatur numquam recusandae et provident dolorem voluptas quos
            nobis dolor a voluptates quisquam, mollitia magnam dicta? Maxime
            id necessitatibus culpa accusamus quo, suscipit atque voluptate
            libero quisquam voluptatibus? Inventore quaerat sapiente dolorem
            illo numquam corporis
          </p>
          <br />
          <p>
            eum nam nobis et beatae tenetur quidem aperiam accusantium culpa,
            reprehenderit suscipit odio? Corporis, nobis laudantium hic enim
            iste recusandae ipsa corporis, quis, maxime a dolorem laboriosam?
            Earum laborum veritatis laboriosam iusto doloribus obcaecati
            assumenda
          </p>
        </div>
          <div className={`${style.btn_okay}`}>
        <NavLink to={"/"+returnTo}>
            <button className={`btn ${style.buttons}`}>Okay</button>
        </NavLink>
          </div>
      </div>
    </div>
  </div>
  )
}

export default ProgramDisclaimers